import iconCommentActive from '../img/icon-comment-active.svg';
import iconCommentActiveBlue from '../img/icon-comment-active-blue.svg';
import iconCommentActiveBlue004986 from '../img/icon-comment-active-blue-004986.svg';
import iconCommentActiveGreen from '../img/icon-comment-active-green.svg';
import iconCommentActiveYellow from '../img/icon-comment-active-yellow.svg';
import iconCommentActiveYellowFADFAA from '../img/icon-comment-active-yellow-fadfaa.svg';
import iconCommentInactive from '../img/icon-comment-none.svg';

export const getFeedbackIcon = (color = '') => {
  switch (color) {
    case 'none':
      return iconCommentInactive;
    case 'blue':
      return iconCommentActiveBlue;
    case 'green':
      return iconCommentActiveGreen;
    case 'yellow':
      return iconCommentActiveYellow;
    case '#004986':
      return iconCommentActiveBlue004986;
    case '#fadfaa':
      return iconCommentActiveYellowFADFAA;
    default:
      return iconCommentActive;
  }
};
